import { getApiActionTypes } from '../storeHelpers';

export const fetchCalcStatusTypes = getApiActionTypes('FETCH_CALC_STATUS');
export const SET_CALC_STATUS = 'SET_CALC_STATUS';
